import { Col, Row } from 'reactstrap'
import { generateGreetings } from 'utils/generateGreetings'

const DynamicHeader = ({ profile }) => {
  const name =
    profile?.data?.makerData?.name ||
    profile?.data?.ownerData?.companyName ||
    ''

  return (
    <div className="my-3" data-testid="homepage-header">
      <Row className="text-start align-items-center mb-3">
        <Col xs="12" md="12" style={{marginLeft:10}}>
          <h3 className="mb-0">
            {generateGreetings()}, {name}!
          </h3>
        </Col>
      </Row>
    </div>
  )
}

export default DynamicHeader
